import type { SearchEngineEventItem } from '~/composables/types/searchEngine'

/** Typesense's events collections are already Algolia-shaped (KFT-4024) — spread + objectID is enough. */
export const toSearchEngineEventItem = (
  document: Record<string, unknown>
): SearchEngineEventItem =>
  ({
    ...document,
    objectID: document.id,
  }) as unknown as SearchEngineEventItem
